import script from "./EmployeeForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeForm.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeForm.vue?vue&type=style&index=0&id=1f3a001c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f3a001c"]])

export default __exports__